const customSizeForm = document.querySelector('.custom-size-form');

if (customSizeForm) {
  const customForm = customSizeForm.innerHTML;

  document.addEventListener('product:variant-change', function(event) {
    const variant = event.detail.variant;

    if (variant && variant.title.includes("Custom")) {
      customSizeForm.innerHTML = customForm;
      customSizeForm.style.display = 'block';
    } else {
      customSizeForm.innerHTML = '';
      customSizeForm.style.display = 'none';
    }
  });
}

// Custom ATC START

document.addEventListener("click", async function(e) {
  const btn = e.target.closest(".custom-product-card-atc");

  if (!btn) return;

  e.preventDefault();

  const originalText = btn.textContent;

  btn.disabled = true;
  btn.textContent = "Adding...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error("Failed to add product");
    }

    btn.textContent = "Added ✓";

    document.dispatchEvent(
      new CustomEvent("quick-cart:open")
    );

    setTimeout(() => {
      btn.disabled = false;
      btn.textContent = originalText;
    }, 1500);

  } catch (error) {
    console.error(error);

    btn.disabled = false;
    btn.textContent = originalText;
  }
});

// Custom ATC END

/* PRODUCT CARD QUICK VIEW */

document.addEventListener("click", function(e) {

  const btn = e.target.closest(".custom-product-card-quickview");

  if (!btn) return;

  e.preventDefault();

  const productCard = btn.closest(".product-item");

  if (!productCard) return;

  const quickViewBtn = productCard.querySelector(".show-product-quickview");

  if (quickViewBtn) {
    quickViewBtn.click();
  }

});

/* END PRODUCT CARD QUICK VIEW */